import React from 'react';

/**
 * Capture les erreurs de rendu d'une page pour éviter que toute l'application
 * ne devienne une page blanche (React démonte la racine sur une erreur non gérée).
 * Affiche le message d'erreur + la pile, avec un bouton pour réessayer.
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, info: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    this.setState({ info });
    // Visible aussi dans la console du navigateur
    // eslint-disable-next-line no-console
    console.error('ErrorBoundary a capturé une erreur :', error, info);
  }

  handleReset = () => this.setState({ error: null, info: null });

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="max-w-2xl mx-auto my-10 bg-white border border-red-200 rounded-xl p-6" data-testid="error-boundary">
        <h2 className="text-lg font-heading font-bold text-red-700 mb-2">Une erreur est survenue sur cette page</h2>
        <p className="text-sm text-stone-600 mb-4">
          La page a rencontré un problème d'affichage. Vous pouvez réessayer ; si le problème persiste,
          communiquez le message ci-dessous au support.
        </p>
        <pre className="text-xs bg-stone-50 border border-stone-200 rounded-lg p-3 overflow-auto max-h-64 text-red-600 whitespace-pre-wrap">
          {String(this.state.error?.stack || this.state.error?.message || this.state.error)}
        </pre>
        <div className="flex gap-3 mt-4">
          <button onClick={this.handleReset}
            className="px-4 py-2 bg-emerald-600 hover:bg-emerald-700 text-white rounded-lg text-sm font-medium">
            Réessayer
          </button>
          <button onClick={() => window.location.reload()}
            className="px-4 py-2 border border-stone-300 bg-white text-stone-700 rounded-lg text-sm font-medium hover:bg-stone-100">
            Recharger la page
          </button>
        </div>
      </div>
    );
  }
}
